export default __webpack_public_path__ + "static/media/KW.75152e7e.svg";